import { getRandomPassword } from 'common/api/auth';

import {
    FETCH_TEMPORAL_PASSWORD,
    FETCH_TEMPORAL_PASSWORD_FAILURE,
    FETCH_TEMPORAL_PASSWORD_SUCCESS,
} from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default (onSuccessCallback) => (dispatch) => {
    dispatch(companyUsersActions[FETCH_TEMPORAL_PASSWORD]());

    getRandomPassword()
        .then((response) => {
            dispatch(
                companyUsersActions[FETCH_TEMPORAL_PASSWORD_SUCCESS](
                    response.data.password,
                ),
            );
            if (onSuccessCallback) onSuccessCallback(response.data.password);
        })
        .catch((error) =>
            dispatch(
                companyUsersActions[FETCH_TEMPORAL_PASSWORD_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
